<template>
	<div class="dialog">
		<el-dialog 
		:show-close="show_closer" 
		:title="title" 
		:visible.sync="visible"
		:close-on-click-modal="close_modal"
		:close-on-press-escape="close_press"
		:width="width" 
		:lock-scroll="lock_scrol" 
		:before-close="handleClose"
		:append-to-body="appendtobody"
		
		
		
		>

			<slot name="body"></slot>

			<span slot="footer" >

				<slot name="footer"></slot>
				
			</span>
			
		</el-dialog>

	</div>
</template>

<script>
	export default {
		name: "defdialog",
		data() {
			return {};
		},
		props: {
			// 是否显示
			show: {
				type: Boolean,
				default: false
			},
			// 
		
			title: {
				type: String,
				default: '',
			},
			width: {
				type: String,
				default: '',
			},
			// 是否显示关闭按钮
			show_closer: {
				type: Boolean,
				default: true
			},
			// 是否可以通过点击 modal 遮罩层 关闭 Dialog
			close_modal: {
				type: Boolean,
				default: false
			},
			// 是否可以通过按下 ESC 关闭 Dialog
			close_press: {
				type: Boolean,
				default: false
			},
			// 是否在 Dialog 出现时将 body 滚动锁定
			lock_scrol: {
				type: Boolean,
				default: false
			},
			// Dialog 自身是否插入至 body 元素上。嵌套的 Dialog 必须指定该属性并赋值为 true
			appendtobody: {
				type: Boolean,
				default: false
			},
			



		},
		computed: {
			visible: {
				get() {
					return this.show
				},
				set(val) {
					this.$emit('update:show', val) // visible 改变的时候通知父组件
				}
			}
		},

		methods: {
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose(done) {
				// this.$emit('handclose')
				this.$emit('update:show', false)
			},
			closeDialog() {
				this.$parent.close();
			},

			onOpen() {
				//打开对话框执行
			},
			close() {
				//手工调用关闭，显示状态为隐藏
				this.$emit('update:show', false)
			},
			
		}

	}
</script>

<style scoped lang="scss">
	.el-link.el-link--default {
		color: var(--themeColors);
	}

	.el-button--mini {
		height: 24px;
	}
	.el-dialog__header {
		border-bottom: 1px solid rgb(195, 195, 195);
		padding: 20px;
	}
	
	.el-dialog {
		border-radius: 5px;
	}
	
	.el-dialog__footer {
		border-radius: 0 0 5px 5px;
	}
	
	.el-dialog__title {
		font-size: 16px;
	}
	
	.el-dialog__close {
		font-size: 24px;
	}
</style>

